const initialPagination = {
    currentPage: 1,
    pageSize: 10,
};


const initialFilters = {
    searchFilters: {
        status: null,
    },
    pagination: initialPagination,
    refreshIndex: 0,
};


export const initialState = {
    predictionCounters: {
        total: 0,
        correct: 0,
        incorrect: 0,
        pending: 0, 
    },
    predictionTimeseries: [],
    recentPredictions: [],
    marketPredictions: [],
    memberRoles: [],
    items: [],
    totalCount: 0,
    filters: initialFilters,
    isLoading: true,
    clearLoading: false,
    searchLoading: false,
    selectedItem: null,
    indexVisibility: 0,
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case 'set_prediction_timeseries':
            return { ...state, predictionTimeseries: action.payload };
        case 'set_recent_predictions':
            return { ...state, recentPredictions: action.payload };
        case 'set_prediction_counters':
            return { ...state, predictionCounters: action.payload };
        case 'set_market_predictions':
            return { ...state, marketPredictions: action.payload };
        case 'set_items':
            return { ...state, items: action.payload.items, totalCount: action.payload.count };
        case 'set_search_filters':
            return { ...state, filters: { ...state.filters, searchFilters: action.payload } };
        case 'set_loading':
            return { ...state, isLoading: action.payload };
        case 'set_refresh_index':
            return { ...state, filters: { ...state.filters, refreshIndex: state.filters.refreshIndex + 1 } };
        case 'set_table_pagination':
            return { ...state, filters: { ...state.filters, pagination: action.payload } };
        case 'set_view':
            return { ...state, indexVisibility: action.payload.index, selectedItem: action.payload.item };
        case 'set_index_visibility':
            const indexVisibility = action.payload;
            const selectedItem = indexVisibility === 0 ? null : state.selectedItem;
            return { ...state, indexVisibility: indexVisibility, selectedItem: selectedItem };
        case 'set_selected_item':
            return { ...state, selectedItem: action.payload };
        case 'reset_state':
            return initialState;
        default:
            return state;
    }
};